/**
 * Aplicación web Directorio del Ayuntamiento de Zamora.
 * 
 * Desarrollo e implementación: Jaime León Pereira.
 * Ingeniero Informático de la Unidad TIC.
 */
import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";

/**
 * Componente de modal de alerta reutilizable.
 * 
 * Muestra mensajes de feedback al usuario con diferentes tipos (éxito, error, advertencia, info)
 * y se cierra automáticamente después de un tiempo definido.
 */
const AlertModal = ({ show, onClose, type = "success", message }) => {

  /* ============================
     Efecto de auto-cierre
     ============================ */
  
  /**
   * Efecto que configura el cierre automático del modal.
   * Se activa cuando el modal se muestra y establece un temporizador
   * para cerrarlo automáticamente después de 2.5 segundos.
   */
  useEffect(() => {
    if (show) {
      // Configurar temporizador para cierre automático
      const timer = setTimeout(onClose, 2500); // 2500ms = 2.5 segundos

      // Cleanup: limpiar el temporizador si el componente se desmonta
      // o si las dependencias cambian antes de que termine el tiempo
      return () => clearTimeout(timer);
    }
  }, [show, onClose]); // Dependencias: se re-ejecuta cuando show u onClose cambian

  /* ============================
     Configuración de colores
     ============================ */
  
  /**
   * Mapa de colores para cada tipo de alerta.
   * Define los colores principales para los iconos y elementos visuales.
   */
  const colors = {
    success: "#28a745",
    error: "#dc3545",
    warning: "#ffc107",
    info: "#0dcaf0",
  };

  /*************************************************************
   *  Renderizado del modal de alerta                          *
   *************************************************************/
  return (
    /* Modal de React-Bootstrap con configuración específica */
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      className="alert-modal shadow-lg border-radius:18px"
    >
      {/* Contenido del modal */}
      <div className="p-4 text-center">
        {/* =============================
            Icono de alerta
            ============================= */}
        <i
          className={`bi ${
            type === "success"
              ? "bi-check-circle-fill"
              : type === "error"
              ? "bi-x-circle-fill"
              : type === "warning"
              ? "bi-exclamation-circle-fill"
              : "bi-info-circle-fill"
          }`}
          style={{ fontSize: "3rem", color: colors[type] }}
        ></i>
        {/* =============================
            Mensaje de alerta
            ============================= */}
        <h5 className="mt-3">{message}</h5>

        {/* =============================
            Botón de cierre manual
            ============================= */}
        <button className="btn btn-primary mt-3" onClick={onClose}>
          Cerrar
        </button>
      </div>
    </Modal>
  );
};

export default AlertModal;
